import { Pipe, PipeTransform } from '@angular/core';
import { Label } from '../../../models/shared/label';
import { Observable } from 'rxjs';
import { LocationConfiguration } from '../../../models/company/dto/location-configuration';
import { CompanyConfiguration } from '../../../models/company/dto/company-configuration';
import { DisplayLabelInterface } from '../../product-labels/label/display-label-interface';
import { map } from 'rxjs/operators';
import { LabelUtils } from '../../product-labels/utils/label-utils';

@Pipe({
  name: 'getDisplayLabelInterfaceForConfirmationModal',
  standalone: false
})
export class GetDisplayLabelInterfaceForConfirmationModalPipe implements PipeTransform {
  transform(
    label: Label,
    configurations$: Observable<[LocationConfiguration, CompanyConfiguration]>
  ): Observable<DisplayLabelInterface> {
    return configurations$.pipe(
      map(configurations => {
        return LabelUtils.getDisplayLabelInterfaceForConfirmationModal(label, configurations);
      })
    );
  }
}
